import { defineSetting } from '../../settingsRegistry';

declare module '../../settingsRegistry' {
  interface Settings {
    /**
     * Cloth that flows (render/rig/cloth.ts): robes, skirts, scarves, capes, sleeves and hair trail with the figure's
     * movement, lag and settle. Off: the rig's own per-pose sway. Figures already drawn keep theirs until a reload.
     */
    cloth: boolean;
  }
}

defineSetting({
  key: 'cloth',
  default: true,
  order: 125,
  menu: {
    group: 'visual',
    label: 'ผ้าพลิ้ว',
    changed: (on) => void import('./cloth').then((m) => m.setClothDefault(on)),
    note: () => 'มีผลกับตัวละครที่โหลดใหม่',
  },
});

// The saved value, once the settings are loaded (settings.ts loads this file while it is being built). Loaded lazily:
// no static import of the rig here, so loading the settings never pulls the rig in mid-way (import cycles).
void Promise.all([import('../../settings'), import('./cloth')]).then(([s, c]) =>
  c.setClothDefault(s.settings.cloth),
);
